// @module Ames.StoreEventsCalendar.StoreEventsCalendar.View
define("Ames.StoreEventsCalendar.StoreEventsCalendar.View", [
  "ames_storeeventscalendar_storeeventscalendar.tpl",
  "Ames.StoreEventsCalendar.StoreEventsCalendar.SS2Model",
  "Ames.StoreEventsCalendar.Details.View",
  "Backbone",
  "CustomContentType.Base.View",
], function (
  ames_storeeventscalendar_storeeventscalendar_tpl,
  StoreEventsCalendarSS2Model,
  AmesStoreEventsCalendarDetailsView,
  Backbone,
  CustomContentTypeBaseView,
) {
  "use strict";

  return CustomContentTypeBaseView.extend({
    template: ames_storeeventscalendar_storeeventscalendar_tpl,

    // Install: fetch events and initialize pagination defaults.
    install: function install(settings, context_data) {
      this.settings = settings;
      // Use a custom field for title if available
      this.calendarName = settings.custrecord_title || "";
      this.calendarEvents = [];
      this.layout = this.application.getLayout();
      this.environment = this.application.getComponent("Environment");
      this.enabledCalendar = this.environment.getConfig(
        "StoreEventsCalendar.enableCalendar",
      );

      this.model = new StoreEventsCalendarSS2Model();
      this.months = [];
      this.days = [];
      this.weeklyDisplay =
        settings.custrecord_weeklydisplay === "T" ? true : false;
      // Initialize current page; pagination state is maintained on the view.
      this.currentPage = 0;
      var self = this;

      this.model
        .fetch({
          data: {
            calendarName: settings.name,
          },
        })
        .done(function (resp) {
          if (!resp || !resp.data || !resp.data.events) {
            console.error("Invalid response from the server.");
            return;
          }
          self.calendarEvents = resp.data.events;
          self.render();
        });

      return this._install(settings, context_data);
    },

    events: {
      'click [data-action="show-event-details"]': "showEventDetails",
      'click [data-action="show-all-events"]': "showAllEvents",
      'click [data-action="prev-page"]': "prevPage",
      'click [data-action="next-page"]': "nextPage",
    },

    showAllEvents: function showAllEvents(e) {
      e.preventDefault();
      Backbone.history.navigate("store-events", { trigger: true });
    },

    showEventDetails: function showEventDetails(e) {
      e.preventDefault();
      var $target = $(e.currentTarget);
      var eventSelected;
      if (!this.weeklyDisplay) {
        var monthIndex = $target.data("month-index");
        var eventIndex = $target.data("event-index");
        eventSelected = this.months[monthIndex].calendarEvents[eventIndex];
      } else {
        var dayIndex = $target.data("day-index");
        var eventIndex = $target.data("event-index");
        eventSelected = this.days[dayIndex].calendarEvents[eventIndex];
      }
      var view = new AmesStoreEventsCalendarDetailsView({
        eventSelected: eventSelected,
      });
      this.layout.showInModal(view);
    },

    prevPage: function prevPage(e) {
      e.preventDefault();
      if (this.currentPage > 0) {
        this.currentPage--;
        this.render();
      }
    },

    nextPage: function nextPage(e) {
      e.preventDefault();
      var totalPages = this.getContext().totalPages;
      if (this.currentPage < totalPages - 1) {
        this.currentPage++;
        this.render();
      }
    },

    bindings: {},
    childViews: {},

    // getContext groups the events based on weeklyDisplay flag and applies pagination.
    getContext: function getContext() {
      if (this.weeklyDisplay) {
        // WEEKLY DISPLAY: Group events by day for the next 14 days.
        // WEEKLY DISPLAY: Group events by day for the next 14 days.
        var allDays = [];
        var startDate = new Date();
        startDate.setHours(0, 0, 0, 0);
        for (var i = 0; i < 14; i++) {
          // Use calendar-based date math instead of milliseconds to avoid DST issues
          var dayDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            startDate.getDate() + i,
          );
          var dayName = dayDate.toLocaleString("default", { weekday: "short" });
          var dayNumber = dayDate.getDate();
          if (dayNumber < 10) {
            dayNumber = "0" + dayNumber;
          }
          allDays.push({
            dayName: dayName,
            date: dayDate,
            index: i,
            dayNumber: dayNumber,
            // Store simple date key for comparison
            dateKey:
              dayDate.getFullYear() +
              "-" +
              dayDate.getMonth() +
              "-" +
              dayDate.getDate(),
            calendarEvents: [],
          });
        }

        var startDisplay = startDate.getTime();
        var endDisplayDate = new Date(
          startDate.getFullYear(),
          startDate.getMonth(),
          startDate.getDate() + 14,
        );
        var endDisplay = endDisplayDate.getTime();

        if (this.calendarEvents && Array.isArray(this.calendarEvents)) {
          this.calendarEvents.forEach(function (event) {
            var eventDate = new Date(event.date);
            eventDate.setHours(0, 0, 0, 0);
            var eventTime = eventDate.getTime();
            event.day = eventDate.getDate();
            if (eventTime >= startDisplay && eventTime < endDisplay) {
              // Compare by year-month-day instead of exact milliseconds
              var eventKey =
                eventDate.getFullYear() +
                "-" +
                eventDate.getMonth() +
                "-" +
                eventDate.getDate();
              var dayObj = allDays.find(function (d) {
                return d.dateKey === eventKey;
              });
              if (dayObj) {
                event.index = dayObj.index;
                dayObj.calendarEvents.push(event);
              }
            }
          });
        }

        allDays.forEach(function (dayObj) {
          dayObj.calendarEvents.sort(function (a, b) {
            return new Date(a.date) - new Date(b.date);
          });
        });

        // display a maximum of 4 events per day
        allDays.forEach(function (dayObj) {
          if (dayObj.calendarEvents.length > 4) {
            dayObj.calendarEvents = dayObj.calendarEvents.slice(0, 4);
          }
        });

        // Determine page size based on viewport width.
        var width = window.innerWidth;
        var pageSize;
        if (width < 600) {
          pageSize = 2;
        } else if (width < 900) {
          pageSize = 4;
        } else {
          pageSize = 7;
        }

        var totalPages = Math.ceil(allDays.length / pageSize);
        if (this.currentPage >= totalPages) {
          this.currentPage = totalPages - 1;
        }
        var startIndex = this.currentPage * pageSize;
        var visibleDays = allDays.slice(startIndex, startIndex + pageSize);
        // Save full days array if needed for event handlers.
        this.days = allDays;

        return {
          calendarName: this.calendarName,
          days: visibleDays,
          weeklyDisplay: this.weeklyDisplay,
          currentPage: this.currentPage + 1, // 1-indexed for display
          totalPages: totalPages,
          pageSize: pageSize,
          enabledCalendar: this.enabledCalendar,
        };
      } else {
        // MONTHLY DISPLAY: Group events into 12 months.
        var allMonths = [];
        var currentDate = new Date();
        var startYear = currentDate.getFullYear();
        var startMonth = currentDate.getMonth();
        for (var j = 0; j < 12; j++) {
          var date = new Date(startYear, startMonth + j, 1);
          var monthName = date.toLocaleString("default", { month: "short" });
          allMonths.push({
            monthName: monthName,
            index: j,
            year: date.getFullYear(),
            monthIndex: date.getMonth(),
            calendarEvents: [],
          });
        }

        var startDisplayMonth = new Date(startYear, startMonth, 1).getTime();
        var endDisplayMonth = new Date(startYear, startMonth + 12, 1).getTime();

        if (this.calendarEvents && Array.isArray(this.calendarEvents)) {
          this.calendarEvents.forEach(function (event, index) {
            var eventDate = new Date(event.date);
            var eventTime = eventDate.getTime();
            event.day = eventDate.getDate();
            if (eventTime >= startDisplayMonth && eventTime < endDisplayMonth) {
              var monthObj = allMonths.find(function (m) {
                return (
                  m.monthIndex === eventDate.getMonth() &&
                  m.year === eventDate.getFullYear()
                );
              });
              event.index = monthObj.index;
              if (monthObj) {
                monthObj.calendarEvents.push(event);
              }
            }
          });
        }

        allMonths.forEach(function (monthObj) {
          monthObj.calendarEvents.sort(function (a, b) {
            return new Date(a.date) - new Date(b.date);
          });
        });

        // Determine page size for months based on viewport.
        var width = window.innerWidth;
        var pageSize;
        if (width < 600) {
          pageSize = 2;
        } else if (width < 900) {
          pageSize = 4;
        } else {
          pageSize = 7;
        }

        var totalPages = Math.ceil(allMonths.length / pageSize);
        if (this.currentPage >= totalPages) {
          this.currentPage = totalPages - 1;
        }
        var startIndex = this.currentPage * pageSize;
        var visibleMonths = allMonths.slice(startIndex, startIndex + pageSize);
        this.months = allMonths;

        return {
          calendarName: this.calendarName,
          months: visibleMonths,
          weeklyDisplay: this.weeklyDisplay,
          currentPage: this.currentPage + 1, // display as 1-indexed
          totalPages: totalPages,
          pageSize: pageSize,
          enabledCalendar: this.enabledCalendar,
        };
      }
    },
  });
});
